export const servicesData = [
  {
    id: 1,
    title: "Pet Hekimliği",
    icon: "ri-heart-pulse-line",
    items: [
      "Koruyucu hekimlik",
      "Düzenli iç-dış parazit",
      "Yıllık sağlık kontrolü",
      "Cerrahi operasyonlar",
      "Ortopedi operasyonları",
      "Ağız ve diş cerrahisi",
      "Laboratuvar hizmetleri",
      "Petshop & Petkuaför",
    ],
    highlight: "Ağız ve diş cerrahisi",
    bgColor: "bg-cream-100",
    description: "Köpek ve kedi dostlarınız için kapsamlı sağlık hizmetleri. Modern teknoloji ve özenli ekibimizle en iyi bakım.",
  },
  {
    id: 2,
    title: "Kuş Bakımı",
    icon: "ri-twitter-line",
    items: [
      "Tüm papağan türleri",
      "Kanarya & Muhabbet kuşu",
      "Teşhis & Tedavi",
      "Cerrahi işlemler",
      "Beslenme danışmanlığı",
      "Tüy ve deri hastalıkları",
      "Solunum yolu tedavisi",
      "Kanat ve tırnak bakımı",
    ],
    highlight: "Tüm papağan türleri",
    bgColor: "bg-primary-50",
    description: "Ankara'nın en kapsamlı kuş veteriner hizmetleri. Papağan, kanarya ve tüm süs kuşları için özel bakım.",
  },
  {
    id: 3,
    title: "Egzotik Hayvanlar",
    icon: "ri-bug-line",
    items: [
      "Sürüngenler (Gecko, İguana)",
      "Kemirgenler & Tavşan",
      "Kirpi & Şeker Planörü",
      "Röntgen & Ultrason",
      "Özel bakım programları",
      "Beslenme düzenleme",
      "Yaşam alanı danışmanlığı",
      "Cerrahi müdahaleler",
    ],
    highlight: "Sürüngenler (Gecko, İguana)",
    bgColor: "bg-cream-100",
    description: "Sürüngenler, kemirgenler ve egzotik memeliler için özel veteriner hizmetleri. Hassas ve özenli yaklaşım.",
  },
];

export const birdTypes = [
  { name: "Kanarya", image: "/assets/images/bird-1.jpg" },
  { name: "Muhabbet Kuşu", image: "/assets/images/bird-2-v2.jpg" },
  { name: "Jako Papağanı", image: "/assets/images/bird-3.jpg" },
  { name: "Sultan Papağanı", image: "/assets/images/bird-4-v2.jpg" },
  { name: "Amazon Papağanı", image: "/assets/images/bird-5.jpg" },
  { name: "Ara Papağanı", image: "/assets/images/bird-6.jpg" },
];

export const exoticTypes = [
  { name: "Leopar Gecko", image: "/assets/images/exotic-1.jpg" },
  { name: "Su Kaplumbağası", image: "/assets/images/exotic-2.jpg" },
  { name: "Hamster", image: "/assets/images/exotic-3.jpg" },
  { name: "Tavşan", image: "/assets/images/exotic-4.jpg" },
];

export const testimonials = [
  {
    id: 1,
    text: "Papağanımız için en iyi bakımı burada bulduk. Özenli yaklaşım sayesinde Jako'muz çok sağlıklı. Özellikle kuş cerrahisi konusundaki başarıları takdire şayan. Herkese tavsiye ederim.",
    author: "Ayşe K.",
    pet: "Jako Papağanı",
    rating: 5,
  },
  {
    id: 2,
    text: "Leopar geckomun deri sorunu için geldik, kısa sürede teşhis konuldu ve tedavi edildi. Egzotik hayvanlar konusunda gerçekten başarılılar. İletişimleri de çok iyi, her soruma sabırla cevap veriyorlar.",
    author: "Mehmet T.",
    pet: "Leopar Gecko",
    rating: 5,
  },
  {
    id: 3,
    text: "Kedimizin diş operasyonu çok başarılı geçti. Ağız ve diş cerrahisi konusunda Ankara'daki en iyi adres. Teşekkürler İhsan Özer Kliniği. Artık tüm evcil hayvanlarımızı buraya getiriyoruz.",
    author: "Zeynep B.",
    pet: "British Shorthair",
    rating: 5,
  },
  {
    id: 4,
    text: "Kanaryamın solunum yolu enfeksiyonunu burada tedavi ettik. Kuşlar konusundaki bilgi ve deneyimleri gerçekten fark yaratıyor. İlaç tedavisi ve beslenme önerileriyle kuşum tamamen iyileşti.",
    author: "Ali R.",
    pet: "Kanarya",
    rating: 5,
  },
];

export const clinicInfo = {
  name: "İhsan Özer Veteriner Kliniği",
  phone: "0539 696 06 77",
  phoneRaw: "05396960677",
  address: "Kavacık Subayevleri Mahallesi, Şehit Makbule Sokak No:2-A-K, Keçiören/Ankara",
  instagram1: "ihsan_ozer_veteriner_klinigi",
  instagram2: "ankarakusveterineri",
  workingHours: "Her Gün: 09:00 - 21:00",
  sunday: "",
  email: "info@ihsanozerveteriner.com",
};

export const detailedServices = [
  {
    id: "kus-bakimi",
    title: "Kuş Bakımı",
    description: "Kafes kuşlarının hastalık teşhis ve tedavileri için kapsamlı veteriner hizmeti sunuyoruz. Türüne özel yaklaşım, doğru teşhis ve düzenli takip ile kuş dostlarınızın sağlığını koruyoruz.",
    icon: "ri-twitter-line",
    features: [
      "Kafes kuşlarının hastalık teşhis ve tedavileri",
      "Kanarya ve muhabbet kuşu muayenesi",
      "Papağan türlerine özel klinik takip",
      "Solunum yolu ve sindirim sistemi tedavileri",
      "Tüy ve deri problemlerinde tedavi",
      "Beslenme ve yaşam alanı danışmanlığı",
    ],
    image: "/assets/images/sc4-jako.jpg",
    highlight: true,
  },
  {
    id: "egzotik-hastalik",
    title: "Egzotik Hayvanların Hastalık Teşhis ve Tedavileri",
    description: "Sürüngenler, kemirgenler ve diğer egzotik türlerde hastalık teşhis ve tedavi süreçlerini deneyimli ekibimizle yürütüyoruz. Tür bazlı bakım protokolleriyle güvenli ve etkili tedavi sunuyoruz.",
    icon: "ri-bug-line",
    features: [
      "Egzotik hayvanların hastalık teşhis ve tedavileri",
      "Leopar gecko, iguana ve kaplumbağa muayenesi",
      "Kemirgen ve tavşanlarda iç hastalık yönetimi",
      "Röntgen ve ultrason ile desteklenen tanı",
      "Paraziter ve enfeksiyöz hastalıkların tedavisi",
      "Uzun dönem bakım ve kontrol planlaması",
    ],
    image: "/assets/images/sc4-gecko.jpg",
  },
  {
    id: "koruyucu",
    title: "Koruyucu Hekimlik",
    description: "Düzenli sağlık kontrolleri, aşılama programları ve parazit tedavileri ile dostlarınızın sağlığını koruyoruz. Erken teşhis hayat kurtarır.",
    icon: "ri-shield-check-line",
    features: ["Yıllık sağlık muayenesi", "İç ve dış parazit tedavisi", "Aşılama programları", "Beslenme danışmanlığı", "Kilo takibi", "Yaşlı hayvan bakımı"],
    image: "/assets/images/svc-1.jpg",
  },
  {
    id: "cerrahi",
    title: "Cerrahi Operasyonlar",
    description: "Modern cerrahi ekipmanlarımız ve deneyimli ekibimizle güvenli operasyon hizmetleri sunuyoruz. Anestezi hekimimiz her operasyonda hazır.",
    icon: "ri-knife-line",
    features: ["Soft tissue cerrahisi", "Kısırlaştırma operasyonları", "Tümör çıkarma", "Yara onarımı", "Laparoskopik cerrahi", "Acil cerrahi müdahale"],
    image: "/assets/images/svc-2.jpg",
  },
  {
    id: "ortopedi",
    title: "Ortopedi Operasyonları",
    description: "Kırık, çıkık ve kemik hastalıklarında özel ortopedik cerrahi hizmetleri. Dijital röntgen ve modern ekipmanlarla doğru teşhis.",
    icon: "ri-hospital-line",
    features: ["Kırık tedavisi (platin, çivi)", "Eklem cerrahisi", "Omurga problemleri", "Rehabilitasyon programları", "Hip displazi tedavisi", "Kemik grefti"],
    image: "/assets/images/svc-3.jpg",
  },
  {
    id: "dis",
    title: "Ağız ve Diş Cerrahisi",
    description: "Ankara'da ağız ve diş cerrahisi konusunda önde gelen kliniğimizde kapsamlı diş tedavileri. Ultrasonik diş temizliği ve cerrahi müdahaleler.",
    icon: "ri-tooth-line",
    features: ["Ultrasonik diş taşı temizliği", "Diş çekimi", "Çene cerrahisi", "Periodontal tedavi"],
    image: "/assets/images/svc-4.jpg",
    highlight: true,
  },
  {
    id: "lab",
    title: "Laboratuvar Hizmetleri",
    description: "Hızlı ve doğru teşhis için modern laboratuvar ekipmanlarımızla hizmet veriyoruz. Aynı gün sonuç garantisi.",
    icon: "ri-flask-line",
    features: ["Tam kan sayımı", "Biyokimya paneli", "İdrar tahlili", "Dışkı analizi", "Mikrobiyolojik kültür", "Hormon testleri", "Alerji testleri"],
    image: "/assets/images/svc-5.jpg",
  },
  {
    id: "teshis",
    title: "Teşhis ve Tedavi",
    description: "Röntgen, ultrason ve detaylı muayene ile doğru teşhis ve etkili tedavi planları. Görüntüleme sonuçlarını aynı gün değerlendiriyoruz.",
    icon: "ri-stethoscope-line",
    features: ["Dijital röntgen", "Ultrasonografi", "EKG", "Detaylı fizik muayene", "Endoskopi", "Dermatolojik testler"],
    image: "/assets/images/svc-6.jpg",
  },
];

export const teamMembers = [
  {
    name: "Dr. İhsan Özer",
    role: "Kurucu Veteriner Hekim",
    specialty: "Kuş & Egzotik Hayvan Hekimi",
    image: "/assets/images/team-1.jpg",
  },
  {
    name: "Dr. Ayşe Yılmaz",
    role: "Veteriner Cerrah",
    specialty: "Ortopedi & Cerrahi",
    experience: "10+ Yıl",
    image: "/assets/images/team-2.jpg",
  },
  {
    name: "Dr. Mehmet Kaya",
    role: "Veteriner Hekim",
    specialty: "Ağız & Diş Cerrahisi",
    experience: "8+ Yıl",
    image: "/assets/images/team-3.jpg",
  },
];

export const whyChooseUs = [
  {
    title: "Köklü Klinik",
    description: "2020'den beri Ankara'da veteriner hizmeti veriyoruz. Binlerce mutlu hasta ve sahibi.",
    icon: "ri-award-line",
  },
  {
    title: "Kuş & Egzotik Uzmanlık",
    description: "Ankara'da kuş ve egzotik hayvanlar konusunda en kapsamlı hizmeti sunan kliniğiz.",
    icon: "ri-twitter-line",
  },
  {
    title: "Modern Ekipman",
    description: "Dijital röntgen, ultrason, modern cerrahi üniteleri ve tam donanımlı laboratuvar.",
    icon: "ri-microscope-line",
  },
  {
    title: "Acil Destek",
    description: "Acil durumlar için telefon desteği ve gerekli durumlarda acil müdahale imkanı.",
    icon: "ri-first-aid-kit-line",
  },
  {
    title: "Ağız & Diş Cerrahisi",
    description: "Ankara'da diş cerrahisi konusunda önde gelen kliniğimizle güvenli tedavi.",
    icon: "ri-tooth-line",
  },
  {
    title: "Pet Kuaför & Shop",
    description: "Kliniğimizde profesyonel pet kuaför ve kaliteli pet ürünleri hizmeti.",
    icon: "ri-scissors-line",
  },
];